import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { decideRequest } from "@/lib/notifications";

// Server-paged notifications with filters + per-item actions (desktop page + mobile screen).
export function usePagedNotifications() {
  const [filter, setFilter] = useState({ unread: false, cat: "" });
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const reqRef = useRef(0);

  const load = (skip = 0) => {
    const id = ++reqRef.current;
    setBusy(true);
    const params = { skip, limit: 50, unread: filter.unread || undefined, category: filter.cat || undefined };
    return api.get("/notifications/page", { params })
      .then((r) => { if (id === reqRef.current) setData((prev) => ({ ...r.data, items: skip && prev ? [...prev.items, ...r.data.items] : r.data.items })); })
      .catch(() => setData((p) => p || { items: [], total: 0, unread: 0, categories: {} }))
      .finally(() => setBusy(false));
  };
  useEffect(() => { load(0); }, [filter]); // eslint-disable-line

  const patch = (id, fn) => setData((p) => ({ ...p, items: p.items.map((x) => (x.id === id ? fn(x) : x)) }));
  const reload = () => load(0);
  return {
    filter, setFilter, data, busy, reload,
    loadMore: () => load(data.items.length),
    markLocal: (n) => patch(n.id, (x) => ({ ...x, read: true })),
    markRead: (n) => { if (!n.read) { patch(n.id, (x) => ({ ...x, read: true })); api.put(`/notifications/${n.id}/read`).catch(() => {}); } },
    toggleRead: async (n) => { await api.put(`/notifications/${n.id}/${n.read ? "unread" : "read"}`).catch(() => {}); reload(); },
    dismiss: async (n) => {
      try { await api.delete(`/notifications/${n.id}`); reload(); } catch (e) { toast.error(e?.response?.data?.detail || "Could not remove"); }
    },
    markAll: async () => { await api.put("/notifications/read-all", null, { params: { category: filter.cat || undefined } }).catch(() => {}); reload(); },
    clearRead: async () => {
      if (!window.confirm("Remove all notifications you've already read? This can't be undone.")) return;
      try { const r = await api.post("/notifications/clear-read"); toast.success(`Removed ${r.data.deleted} read notification${r.data.deleted === 1 ? "" : "s"}`); reload(); }
      catch { toast.error("Could not clear"); }
    },
    act: async (n, which) => { if (await decideRequest(n, which)) reload(); },
  };
}
